export const getGuestsText = (params: {
  numberOfAdults: number;
  numberOfChildren: number;
  agesOfChildren: number[];
  disableChildren: boolean;
}): string => {
  const { numberOfAdults, numberOfChildren, agesOfChildren, disableChildren } = params;
  const composedNumberOfAdults = `${numberOfAdults} Erw.`;
  const composedNumberOfChildren = `${
    numberOfChildren > 1 || numberOfChildren < 1
      ? `,${numberOfChildren} Kinder`
      : `,${numberOfChildren} Kind`
  }`;
  const composedAgesOfChildren = `${
    numberOfChildren > 0
      ? `(${agesOfChildren.join(', ')} ${
          agesOfChildren.length === 1 && agesOfChildren[0] === 1 ? 'Jahr' : 'Jahre'
        })`
      : ''
  }`;
  return `${composedNumberOfAdults} ${!disableChildren ? composedNumberOfChildren : ''} ${composedAgesOfChildren}`.trim();
};
